import React from "react";
import styles from "./styles.module.scss";
import Input from "@/components/input/input";
import { Modal } from "@aqar-app/react-ui";
import { Button, Checkbox } from "@aqar-app/aqar-design-system";
import { useMutation } from "@apollo/client";
import { useAuthState } from "@/contexts/auth/auth.provider";
import Icon from "@/components/icon";
import logger from "@/console";
import { isSaudiNumber } from "@/lib/helpers";
import { INIT_PAYMENT_REQUEST } from "@/graphql/mutations/realEstateProjects";
import {
  trackSendPaymentRequestLinkConfirm,
  trackSendPaymentRequestLinkSuccess,
} from "@/lib/tracking/trackExclusiveUnitBookingEvents";

const DownPaymentRequestModal = ({ unitId }) => {
  const [customerPhoneError, setCustomerPhoneError] = React.useState(false);
  const [isChecked, setIsChecked] = React.useState(false);
  const [customerPhone, setCustomerPhone] = React.useState("");
  const [success, setSuccess] = React.useState(false);

  const { token } = useAuthState();

  const [initPaymentRequest, { loading, error }] = useMutation(
    INIT_PAYMENT_REQUEST,
    {
      context: { token },
      onCompleted: () => {
        setSuccess(true);
      },
    },
  );

  if (success) {
    return (
      <div className={styles.downPaymentRequestModal}>
        <div className={styles.header}>
          <h2>عقار</h2>
        </div>
        <div className={styles.content}>
          <h3>تم إرسال طلب دفع العربون للعميل بنجاح</h3>
          <Button
            priority="tertiary"
            onClick={() => {
              trackSendPaymentRequestLinkSuccess();
              Modal.close();
            }}
          >
            حسنًا
          </Button>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.downPaymentRequestModal}>
        <div className={styles.header}>
          <h2>عقار</h2>
        </div>
        <div className={styles.content}>
          <h3>{error.message}</h3>
          <Button
            priority="tertiary"
            onClick={() => {
              Modal.close();
            }}
          >
            حسنًا
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.downPaymentRequestModal}>
      <div className={styles.header}>
        <h2>طلب دفع العربون</h2>
        <Icon
          className={styles.close}
          name="Close"
          onClick={() => Modal.close()}
          width={14}
          height={14}
        />
      </div>
      <div className={styles.content}>
        <label>رقم جوال العميل</label>
        <Input
          type="number"
          value={customerPhone}
          onChange={(e) => {
            const { value } = e.target;
            setCustomerPhone(value);
            setCustomerPhoneError(!isSaudiNumber(value));
          }}
          className={styles.phoneInput}
          placeholder="أدخل هنا..."
        />
        {customerPhoneError && (
          <label className={styles.error}>رقم الجوال المدخل غير صحيح</label>
        )}

        <div className={styles.checkbox}>
          <Checkbox
            label={
              <span>أقر بتواصلي مع العميل وبجدية رغبته في شراء الوحدة.</span>
            }
            onChange={setIsChecked}
          />
          <p className={styles.disclaimer}>
            * سيتم حجز الوحدة للعميل للدفع لمدة 30 دقيقة.
          </p>
        </div>

        <Button
          disabled={!isChecked || loading || !isSaudiNumber(customerPhone)}
          priority="tertiary"
          onClick={() => {
            trackSendPaymentRequestLinkConfirm();
            initPaymentRequest({
              variables: {
                listing_id: unitId,
                buyer_phone_number: customerPhone,
              },
            }).catch(logger.log);
          }}
        >
          إرسال
        </Button>
      </div>
    </div>
  );
};

export default DownPaymentRequestModal;
